import React, { FC } from 'react';

import { Box } from '@rover/kibble/core';
import { ZIndex } from '@rover/kibble/styles';
import { useTheme } from '@rover/kibble/themes';
import useDeviceContext from '@rover/react-lib/src/context/useDeviceContext';
import usePageContext from '@rover/react-lib/src/context/usePageContext';
import AdminToolbar from '@rover/shared/js/ssr/BaseTemplate/AdminToolbar';
import AppInstallBanner from '@rover/shared/js/ssr/BaseTemplate/AppInstallBanner';
import GlobalAnnouncements from '@rover/shared/js/ssr/BaseTemplate/GlobalAnnouncements';
import NavBar from '@rover/shared/js/ssr/BaseTemplate/NavBar';
import SkipToMainContentLink from '@rover/shared/js/ssr/BaseTemplate/NavBar/SkipToMainContentLink';

import BHNavbarProvider, { useBHNavbarContext } from './context/BHNavbarContext';

const Header: FC = () => {
  const { suppressHeader } = usePageContext();
  const { isEmbedded } = useDeviceContext();
  const { isBrightHorizonsNavigation } = useBHNavbarContext();

  const theme = useTheme();

  if (suppressHeader) return null;

  return (
    <Box
      as="header"
      display={isEmbedded ? 'none' : 'initial'}
      position={isBrightHorizonsNavigation ? 'sticky' : 'relative'}
      top="0x"
      zIndex={ZIndex.NAVBAR.toString()}
    >
      <SkipToMainContentLink />
      <AdminToolbar />
      {!isBrightHorizonsNavigation && <AppInstallBanner />}
      <Box
        display={['flex', 'block']}
        flexDirection="column"
        background="navigation"
        borderBottom={`1px solid ${theme.colors.border.primary.toString()}`}
      >
        <GlobalAnnouncements />
        <NavBar />
      </Box>
    </Box>
  );
};

const HeaderContainer: FC = () => {
  return (
    <BHNavbarProvider>
      <Header />
    </BHNavbarProvider>
  );
};

export default HeaderContainer;
